import React, { useState } from "react";
import { Field, FormSpy } from "react-final-form";
import { Label } from "../../../shared/components/form/Layout";
import DateInput from "../../../shared/components/form/DateInput";
import Input from "../../../shared/components/form/Input";
import StopSelect from "../../../booking/components/form/StopSelect";
import FieldContainer from "../../../shared/containers/form/FieldContainer";
import ErrorContainer from "../../../shared/containers/form/ErrorContainer";
import { useTranslation } from "react-i18next";
import { selectArrival, selectDeparture } from "../../../../data/booking/actions/map";
import { useDispatch, useSelector } from "react-redux";
import Divider from "../../../shared/components/Divider";
import SlideInAnimation from "../../../shared/components/SlideInAnimation";
import WithStage from "../../../shared/components/form/WithStage";
import {
    MapPinIcon,
    CalendarIcon, UserGroupIcon,ClockIcon
} from "@heroicons/react/20/solid";
import InputNumber from "../../../shared/components/form/InputNumber";
import moment from "moment/moment";
import Tooltip from "../../../shared/components/Tooltip";
import {startAt} from "../../../../data/booking/selectors/people_transport_form";

const ItemFormFields = ({ routeId, form }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isEditing = useSelector((state) => state.booking.booking.editingService);
    const startAtDate = useSelector(state => startAt(state.booking))

    return (
        <WithStage form={form} isEditing={isEditing}>
            {({updateStage, getFieldStage, stage })=> (<>
                <FormSpy
                    subscription={{ values: true }}
                    onChange={(values) => updateStage(values.values)}
                />
                <Divider className={"my-8"}>Personnes et date</Divider>
                <section className="px-4 sm:flex sm:gap-16 sm:px-16">
                    <div className="sm:w-1/2">
                        <FieldContainer name="people">
                            <Label Icon={UserGroupIcon} htmlFor="people" className="col-xs-7">
                                {t("booking.people_count")}
                            </Label>
                            <div className="col-xs-5 no-padding">
                                <Field
                                    className="form-control"
                                    id="people"
                                    name="people"
                                    placeholder="0"
                                    component={InputNumber}
                                />
                            </div>
                            <ErrorContainer name="people" />
                        </FieldContainer>
                    </div>
                    <div className="mt-8 sm:mt-0 sm:w-1/2">
                        <div className="step-cell col-xs-4">
                            <FieldContainer name="date">
                                <Label
                                    Icon={CalendarIcon}
                                    htmlFor="date"
                                    className="col-xs-3"
                                >
                                    {t("booking.departure_date")}
                                    <Tooltip content="Pas de demande possible pour le lendemain" className={"ml-2"} />
                                </Label>
                                <div className="col-xs-8">
                                    <Field
                                        id="date"
                                        name="date"
                                        placeholder="jj/mm/aaaa"
                                        component={DateInput}
                                        disabledAfter={startAtDate}
                                    />
                                    <ErrorContainer  name="date" />
                                </div>
                            </FieldContainer>
                        </div>
                    </div>
                </section>
                <SlideInAnimation show={stage >= getFieldStage("date")}>
                    <Divider>Départ</Divider>
                    <div className="space-y-8 px-4 lg:px-16">
                        <FieldContainer name="from" >
                            <Label htmlFor="from" Icon={MapPinIcon}>
                                {t("booking.departure_from")}
                            </Label>
                            <Field
                                id="from"
                                name="from"
                                routeId={routeId}
                                component={StopSelect}
                                onChange={(value) => {
                                    dispatch(selectDeparture(value?.firstInput?.step));
                                }}
                            />
                            <ErrorContainer name="from" />
                        </FieldContainer>
                    </div>
                </SlideInAnimation>
                <SlideInAnimation show={stage >= getFieldStage("from")}>
                    <Divider>Arrivée</Divider>
                    <div className="space-y-8 px-4 lg:px-16">
                        <FieldContainer name="to">
                            <Label htmlFor="to" Icon={MapPinIcon}>
                                {t("booking.departure_to")}
                            </Label>
                            <Field
                                id="to"
                                name="to"
                                routeId={routeId}
                                onChange={(value) => {
                                    dispatch(selectArrival(value?.firstInput?.step));
                                }}
                                component={StopSelect}
                            />
                            <ErrorContainer name="to" />
                        </FieldContainer>
                    </div>
                </SlideInAnimation>
                <SlideInAnimation show={stage >= getFieldStage("to")}>
                    <Divider>Horaire</Divider>
                    <div className="space-y-8 px-4 lg:px-16">
                        <FieldContainer name="hour">
                            <Label htmlFor="hour" Icon={ClockIcon}>
                                Heure souhaitée de départ
                            </Label>
                            <Field
                                id="time"
                                name="hour"
                                component={Input}
                                placeholder="HH:MM"
                            />
                            <ErrorContainer name="hour" />
                        </FieldContainer>
                    </div>
                </SlideInAnimation>
            </>)}
        </WithStage>
    );
};

export default ItemFormFields;
